<template>
  <div class="lookUser">
    <el-dialog
      title="查看学员"
      :visible.sync="dialogVisible"
      width="1360px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <WrittenGrade v-if="dialogVisible" :testPlanId="testPlanId" :type="type" />
    </el-dialog>
  </div>
</template>

<script>
import WrittenGrade from '../../writtenGrade/index.vue'
export default {
  name: 'LookUser',
  components: { WrittenGrade },
  data () {
    return {
      dialogVisible: false,
      testPlanId: '',
      type: ''
    }
  },
  methods: {
    init(testPlanId, type) {
      this.testPlanId = testPlanId
      this.type = type
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
